import { useState, useEffect } from 'react'
import { useUser } from '../hooks/useUser'
import ApiService from '../services/ApiService'
import Sidebar from './Sidebar'
import ChangePassword from './ChangePassword'
import InviteUser from './InviteUser'

function Layout({ children }) {
  const { currentUser, isAdmin, logout, theme, toggleTheme } = useUser()
  const [version, setVersion] = useState(null)
  const [showChangePassword, setShowChangePassword] = useState(false)
  const [showInviteUser, setShowInviteUser] = useState(false)

  useEffect(() => {
    ApiService.getVersion()
      .then(setVersion)
      .catch(() => {
        console.warn('Failed to load version info')
      })
  }, [])

  return (
    <>
      <div className="topbar">
        <span className="brand">ReplySense</span>
        <div className="user-info">
          {currentUser && (
            <>
              <span className="user-name">{currentUser.full_name}</span>
              {isAdmin && (
                <span className="user-role">{currentUser.role}</span>
              )}
            </>
          )}
          {isAdmin && (
            <button
              onClick={() => setShowInviteUser(true)}
              className="header-btn"
            >
              Invite User
            </button>
          )}
          <button
            onClick={toggleTheme}
            className="header-btn"
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <button
            onClick={() => setShowChangePassword(true)}
            className="header-btn"
          >
            Change Password
          </button>
          <button onClick={logout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>

      <div className="body-wrapper">
        <Sidebar version={version} />

        <main className="main">
          {children}
        </main>
      </div>

      {showChangePassword && (
        <ChangePassword
          onClose={() => setShowChangePassword(false)}
          user={currentUser}
        />
      )}

      {showInviteUser && (
        <InviteUser
          onClose={() => setShowInviteUser(false)}
        />
      )}
    </>
  )
}

export default Layout